"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notifications = void 0;
var _hooks = require("../../../../hooks");
var _Icon = require("../../../../UI/Icon");
var _Menu = require("../../../../UI/Menu");
var _Header = require("../Header.labels");
var _jsxRuntime = require("react/jsx-runtime");
const Notifications = props => {
  const {
    user,
    notifications
  } = props;
  const getLabel = (0, _hooks.useLabels)({
    labels: _Header.labels
  });
  const hasNotifications = Boolean(notifications && notifications.length > 0);
  const options = hasNotifications ? notifications : [{
    value: 'none',
    label: getLabel('no_notifications')
  }];
  if (!user?.userId) return null;
  const btnProps = {
    view: 'alternate',
    color: 'basic',
    shape: 'round',
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      name: hasNotifications ? 'NotificationsOn' : 'Notifications',
      width: "20",
      height: "20"
    })
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu.Menu, {
      options: options,
      btnProps: btnProps
    })
  });
};
exports.Notifications = Notifications;